export default __webpack_public_path__ + "static/media/hr1.f8de8cce.png";